import { Group, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

/**
 * The provider's mark, deliberately discreet (design system §1): the isotype of FMC Sistemas in
 * grey plus one line of text. Only the login stage and the future "Acerca de" page use it.
 */
export function FmcCredit() {
  const { t } = useTranslation('auth');

  return (
    <Group gap={8} wrap="nowrap">
      <svg width="14" height="15.5" viewBox="0 0 66 73.2" aria-hidden="true">
        <rect x="0" y="0" width="66" height="20" rx="3" fill="#8A9096" />
        <rect x="0" y="26.6" width="48.84" height="20" rx="3" fill="#B4B9BE" />
        <rect
          x="0.5"
          y="53.7"
          width="30.68"
          height="19"
          rx="2.5"
          fill="none"
          stroke="#8A9096"
          strokeWidth="2"
        />
      </svg>
      <Text size="xs" c="gray.5">
        {t('credit.fmc')}
      </Text>
    </Group>
  );
}
